/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

const STICKY_PARAMS: ReadonlySet<string> = new Set([
    'device',
    'mobile',
    'perf',
    'theme',
    'debug',
    'noCache',
    'disableApq',
    'logLevel',
    'authPortal',
    'feedStub',
    'noTakeover',
    'fullscreen',
])

const STICKY_PARAM_PREFIX = 'feature.'

export function isStickyParam(name: string): boolean {
    return STICKY_PARAMS.has(name) || name.startsWith(STICKY_PARAM_PREFIX)
}

/**
 * Adds the sticky app-level params of `currentSearch` to the in-app `path`'s query.
 * A sticky param the path already sets wins; page-specific params are never carried.
 */
export function withStickyParams(path: string, currentSearch: string): string {
    const queryIndex = path.indexOf('?')
    const pathname = queryIndex >= 0 ? path.slice(0, queryIndex) : path
    const query = queryIndex >= 0 ? path.slice(queryIndex + 1) : ''
    const params = new URLSearchParams(query)
    for (const [name, value] of new URLSearchParams(currentSearch)) {
        if (isStickyParam(name) && !params.has(name)) params.append(name, value)
    }
    const merged = params.toString()
    return merged ? `${pathname}?${merged}` : pathname
}
